interface MedicationEditorNavigation {
  getParent():
    | {
        navigate(
          screen: "MedicationsVaccinesFlow",
          params: { screen: "MedicationsIntro" },
        ): void;
      }
    | undefined;
}

export function navigateToMedicationEditor(
  navigation: MedicationEditorNavigation,
) {
  navigation
    .getParent()
    ?.navigate("MedicationsVaccinesFlow", { screen: "MedicationsIntro" });
}
